import { lastNights, nightLabel, nightStatus } from "../../lib/backups";

const CELL = {
  ready:   "bg-grass",
  failed:  "bg-scarlet",
  running: "bg-cobalt/60",
  none:    "bg-ink/10",
};

/** Thirty tiles, one per Pacific night: green copy, red failure, grey gap. */
export const BackupNightStrip = ({ rows, nights = 30 }) => {
  const byNight = nightStatus(rows);
  const days = lastNights(nights);
  const today = days[days.length - 1];
  const gaps = days.filter((d) => d !== today && !byNight[d]).length;
  const fails = days.filter((d) => byNight[d]?.status === "failed").length;

  return (
    <div className="rounded-xl border border-border bg-bone p-5" data-testid="backup-night-strip">
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <p className="text-[10px] font-semibold uppercase tracking-[0.22em] text-olive">Last {nights} nights</p>
        <p className="text-xs text-olive" data-testid="backup-gap-summary">
          {gaps === 0 && fails === 0
            ? "No gaps."
            : [gaps ? `${gaps} night${gaps === 1 ? "" : "s"} without a copy` : null, fails ? `${fails} failed` : null].filter(Boolean).join(" · ")}
        </p>
      </div>
      <div className="mt-3 grid gap-1" style={{ gridTemplateColumns: `repeat(${nights}, minmax(0, 1fr))` }} role="list">
        {days.map((d) => {
          const s = byNight[d]?.status || (d === today ? "today" : "none");
          const title = `${nightLabel(d)}: ${s === "today" ? "tonight's run pending" : s === "none" ? "no copy" : s}`;
          return (
            <span
              key={d}
              role="listitem"
              title={title}
              data-testid={`backup-night-${d}`}
              data-status={s}
              className={`h-6 rounded-sm ${s === "today" ? "border border-dashed border-ink/30" : CELL[s]}`}
            />
          );
        })}
      </div>
      <div className="mt-3 flex flex-wrap gap-4 text-[11px] text-olive">
        <span className="inline-flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm bg-grass" /> copy made</span>
        <span className="inline-flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm bg-scarlet" /> failed</span>
        <span className="inline-flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm bg-ink/10" /> no copy</span>
        <span className="inline-flex items-center gap-1.5"><i className="h-2.5 w-2.5 rounded-sm border border-dashed border-ink/30" /> tonight</span>
      </div>
    </div>
  );
};
